// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TenorCustomDateRangeFromJSON(json) {
    return {
        'startDate': !exists(json, 'startDate') ? undefined : new Date(json['startDate']),
        'endDate': !exists(json, 'endDate') ? undefined : new Date(json['endDate']),
    };
}
export function TenorCustomDateRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'startDate': value.startDate === undefined ? undefined : value.startDate.toISOString(),
        'endDate': value.endDate === undefined ? undefined : value.endDate.toISOString(),
    };
}
